import { render, staticRenderFns } from "./InsuranceFormPayment.vue?vue&type=template&id=5c5df30d&"
import script from "./InsuranceFormPayment.vue?vue&type=script&lang=js&"
export * from "./InsuranceFormPayment.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceFormPayment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports